import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import { CampusGroupSingleTabActivities, CampusGroupSingleTabUsers, CampusGroupSingleTabStaff, CampusGroupSingleTabAttendance, EditIcon, Tabs, Dialog, DialogCampusGroupSingleEditGroup, DialogCampusGroupSingleAddStaffTrainer, DialogCampusGroupSingleAddStaffCoordinator, DialogCampusGroupSingleActivity, ButtonPopover, canFunction, Breadcrumb, Can, SwitchStatus, LoadingTemplate, ErrorTemplate } from "../../../../../";
import DeleteIcon from "@material-ui/icons/Delete";
import moment from "moment";
import { Link } from "react-router-dom";
var useStyles = makeStyles(function (theme) {
  return {
    box: {
      display: "flex",
      "align-items": "center",
      "border-radius": "4px",
      border: "1px solid #7d7d7d"
    },
    titleCard: {
      textAlign: "center",
      width: "100%",
      margin: "16px 0"
    },
    actionsTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    mt50: {
      marginTop: "50px"
    },
    editIcon: {
      color: "#ffe082",
      marginLeft: "8px",
      cursor: "pointer"
    },
    titleCampus: {
      display: "flex",
      alignItems: "center"
    },
    link: {
      textDecoration: "none",
      color: theme.palette.text.primary,
      "&:hover": {
        color: theme.palette.primary.main,
        transition: "0.3s all ease-in-out"
      }
    }
  };
});
var defaultTabs = [{
  value: "activities",
  label: "Activities"
}, {
  value: "users",
  label: "Users"
}, {
  value: "staff",
  label: "Staff"
}, {
  value: "attendance",
  label: "Assistance"
}];

var WebCampusGroupSingle = function WebCampusGroupSingle(props) {
  var _useState = useState("activities"),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDialogAddStaffTrainer = _useState4[0],
      setOpenDialogAddStaffTrainer = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openDialogActivity = _useState6[0],
      setOpenDialogActivity = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      openDialogAddStaffCoordinator = _useState8[0],
      setOpenDialogAddStaffCoordinator = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      openDialogEditGroup = _useState10[0],
      setOpenDialogEditGroup = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      openDialogDeleteGroup = _useState12[0],
      setOpenDialogDeleteGroup = _useState12[1]; //POPOVER LABELS


  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      labelsPopover = _useState14[0],
      setLabelsPopover = _useState14[1];

  var classes = useStyles();
  useEffect(function () {
    var auxLabels = [];
    props.translation && props.translation.popovers && props.translation.popovers.campus && props.translation.popovers.campus.labels.forEach(function (label) {
      canFunction({
        role: props.role,
        perform: label.perform
      }).then(function (x) {
        auxLabels.push(label);
      });
    });
    setLabelsPopover(auxLabels);
  }, [props.translation, props.role]); // FUNCTION POPOVER

  var handleItemPopoverClick = function handleItemPopoverClick(type) {
    switch (type) {
      case "add_activity":
        handleModalDialogActivity();
        break;

      case "add_staff_trainer":
        handleModalDialogAddStaffTrainer();
        break;

      case "add_staff_coordinator":
        handleModalDialogAddStaffCoordinator();
        break;

      default:
        break;
    }
  }; // FUNCTIONS DIALOG


  var handleModalDialogActivity = function handleModalDialogActivity() {
    setOpenDialogActivity(!openDialogActivity);
  };

  var handleModalDialogEditGroup = function handleModalDialogEditGroup() {
    setOpenDialogEditGroup(!openDialogEditGroup);
  };

  var handleModalDialogDeleteGroup = function handleModalDialogDeleteGroup() {
    setOpenDialogDeleteGroup(!openDialogDeleteGroup);
  };

  var handleModalDialogAddStaffTrainer = function handleModalDialogAddStaffTrainer() {
    setOpenDialogAddStaffTrainer(!openDialogAddStaffTrainer);
  };

  var handleModalDialogAddStaffCoordinator = function handleModalDialogAddStaffCoordinator() {
    setOpenDialogAddStaffCoordinator(!openDialogAddStaffCoordinator);
  }; // FUNCTIONS TAB


  var handleTabs = function handleTabs(event, newValue) {
    setValue(newValue);
  }; // RENDER TAB CONTENT


  var renderContentTabs = function renderContentTabs() {
    var content;

    switch (value) {
      case "activities":
        content = /*#__PURE__*/React.createElement(CampusGroupSingleTabActivities, {
          events: props.calendarEvents,
          activities: props.activities,
          venues: props.venues,
          translation: props.translation ? props.translation.activities : null,
          campusGroupData: props.campusGroupData,
          handleDeleteActivity: props.handleDeleteActivity,
          handleEditActivity: props.handleEditActivity
        });
        break;

      case "users":
        content = /*#__PURE__*/React.createElement(CampusGroupSingleTabUsers, {
          users: props.users,
          translation: props.translation ? props.translation.users : null,
          handleEditUser: props.handleEditUser,
          handleDeleteUser: props.handleDeleteUser
        });
        break;

      case "staff":
        content = /*#__PURE__*/React.createElement(CampusGroupSingleTabStaff, {
          role: props.role,
          staff: props.staff,
          translation: props.translation ? props.translation.staff : null,
          downloadStaffInfo: props.downloadStaffInfo,
          handleDeleteStaff: props.handleDeleteStaff,
          handleViewCertificate: props.handleViewCertificate
        });
        break;

      case "attendance":
        if (!props.attendance.downloaded) {
          props.handleDownloadAttendances();
        }

        content = /*#__PURE__*/React.createElement(CampusGroupSingleTabAttendance, {
          attendance: props.attendance,
          translation: props.translation ? props.translation.attendance : null,
          handleDownloadAttendance: props.handleDownloadAttendance
        });
        break;

      default:
        content = "";
        break;
    }

    return content;
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(SwitchStatus, {
    status: props.status,
    downloading: function downloading() {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: "100vh",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(LoadingTemplate, {
        text: props.translation ? props.translation.templates ? props.translation.templates.downloading || "Downloading" : "Downloading" : "Downloading"
      }));
    },
    loading: function loading() {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: "100vh",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(LoadingTemplate, {
        text: props.translation ? props.translation.templates ? props.translation.templates.loading || "Loading" : "Loading" : "Loading"
      }));
    },
    error: function error() {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: "100vh",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(ErrorTemplate, {
        text: props.translation ? props.translation.templates ? props.translation.templates.error || "Error" : "Error" : "Error"
      }));
    },
    success: function success() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dialog, {
        open: openDialogDeleteGroup,
        onClose: handleModalDialogDeleteGroup,
        title: props.translation ? props.translation.dialogs ? props.translation.dialogs.delete_group ? props.translation.dialogs.delete_group.title || "Do you want to remove this group?" : "Do you want to remove this group?" : "Do you want to remove this group?" : "Do you want to remove this group?",
        text: props.translation ? props.translation.dialogs ? props.translation.dialogs.delete_group ? props.translation.dialogs.delete_group.text || "You will lose all content from this group" : "You will lose all content from this group" : "You will lose all content from this group" : "You will lose all content from this group",
        submit: props.translation ? props.translation.dialogs ? props.translation.dialogs.delete_group ? props.translation.dialogs.delete_group.buttons ? props.translation.dialogs.delete_group.buttons.submit || "Delete" : "Delete" : "Delete" : "Delete" : "Delete",
        buttonColorSubmit: "secondary",
        buttonVariantSubmit: "contained",
        onCancel: handleModalDialogDeleteGroup,
        cancel: props.translation ? props.translation.dialogs ? props.translation.dialogs.delete_group ? props.translation.dialogs.delete_group.buttons ? props.translation.dialogs.delete_group.buttons.cancel || "Cancel" : "Cancel" : "Cancel" : "Cancel" : "Cancel",
        buttonColorCancel: "secondary",
        buttonVariantCancel: "outlined",
        onSubmit: function onSubmit() {
          props.handleDeleteGroup();
          handleModalDialogDeleteGroup();
        }
      }), /*#__PURE__*/React.createElement(DialogCampusGroupSingleEditGroup, {
        open: openDialogEditGroup,
        onClose: handleModalDialogEditGroup,
        onSubmit: props.handleEditGroup,
        projects: props.projects,
        data: props.campusGroupData,
        translation: props.translation ? props.translation.dialogs ? props.translation.dialogs.edit_group || null : null : null
      }), /*#__PURE__*/React.createElement(DialogCampusGroupSingleActivity, {
        open: openDialogActivity,
        onClose: handleModalDialogActivity,
        onSubmitAdd: props.handleAddActivity,
        variant: "add",
        venues: props.venues,
        translation: props.translation ? props.translation.dialogs ? props.translation.dialogs.add_activity || null : null : null
      }), /*#__PURE__*/React.createElement(DialogCampusGroupSingleAddStaffTrainer, {
        translation: props.translation ? props.translation.dialogs ? props.translation.dialogs.add_staff_trainer || null : null : null,
        groupId: props.groupId,
        open: openDialogAddStaffTrainer,
        sm_staff: props.sm_staff,
        campus_staff: props.campus_staff,
        onClose: handleModalDialogAddStaffTrainer,
        handleDownloadSMStaff: props.handleDownloadSMStaff,
        onSubmit: props.handleAddStaffTrainer
      }), /*#__PURE__*/React.createElement(DialogCampusGroupSingleAddStaffCoordinator, {
        translation: props.translation ? props.translation.dialogs ? props.translation.dialogs.add_staff_coordinator || null : null : null,
        open: openDialogAddStaffCoordinator,
        groupId: props.groupId,
        sm_staff: props.sm_staff,
        campus_staff: props.campus_staff,
        onClose: handleModalDialogAddStaffCoordinator,
        handleDownloadSMStaff: props.handleDownloadSMStaff,
        onSubmit: props.handleAddStaffCoordinator
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Breadcrumb, null, /*#__PURE__*/React.createElement(Link, {
        to: "/campus/".concat(props.campusId),
        className: classes.link
      }, props.campusName), /*#__PURE__*/React.createElement(Typography, {
        color: "primary"
      }, props.campusGroupData ? props.campusGroupData.name : ""))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 10
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.titleCampus
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h4"
      }, props.campusGroupData ? props.campusGroupData.name || "Group" : "Group", props.campusName ? " - " + props.campusName || " - Campus" : " - Campus"), /*#__PURE__*/React.createElement(EditIcon, {
        className: classes.editIcon,
        onClick: handleModalDialogEditGroup
      }), /*#__PURE__*/React.createElement(Can, {
        role: props.role,
        perform: "campus:group:delete_group",
        yes: function yes() {
          return /*#__PURE__*/React.createElement(DeleteIcon, {
            color: "secondary",
            className: classes.icon,
            onClick: handleModalDialogDeleteGroup
          });
        },
        no: function no() {
          return null;
        }
      })), /*#__PURE__*/React.createElement(Typography, {
        variant: "h6"
      }, props.campusGroupData ? props.campusGroupData.date && props.campusGroupData.date.start && props.campusGroupData.date.end ? "".concat(moment(props.campusGroupData.date.start).format("DD/MM/YYYY"), "-").concat(moment(props.campusGroupData.date.end).format("DD/MM/YYYY")) : "Sin fecha" : "Sin fecha")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 2,
        className: classes.actionsTitle
      }, /*#__PURE__*/React.createElement(ButtonPopover, {
        labels: labelsPopover,
        handleItemClick: handleItemPopoverClick
      }, props.translation ? props.translation.popovers ? props.translation.popovers.campus ? props.translation.popovers.campus.label || "+ Button" : "+ Button" : "+ Button" : "+ Button")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Tabs, {
        value: value,
        onChange: handleTabs,
        variant: "fullWidth" // className={classes.mb30}
        ,
        indicatorColor: "primary",
        textColor: "primary",
        contentTabs: props.translation ? props.translation.tabs || defaultTabs : defaultTabs
      })), renderContentTabs());
    }
  }));
};

export { WebCampusGroupSingle };